( function( window ) {
var $ = window.jQuery;

$.fn.extend( {
	PricingForm: function( options ) {
		this.options = options;
		var myInstance = this;
		var $ = window.jQuery;
		this.form = this;
		this.dimensionsFields = this.find( "#pricing_form__dimensions" );
		this.submitButton = this.find( "#pricing_form__submit" );
		this.checkImportButton = this.find( "#check_import_prices_button" );
		this.loaderGraphic = this.find( "#pricing_form__loading" );
		this.resultContainer = this.find( "#pricing_form__results" );
		this.dimensionsDisclaimer = this.find( "#pricing_form__dimensions_disclaimer" );

		//console.log( "hi i am superintelligent pricing form" );

		// Handle package change - if custom, show dimensions fields
		this.onPackageChange = function( e ) {
			if( $( e.target ).val() === "custom" ) {
				myInstance.dimensionsFields.slideDown();
			} else {
				myInstance.dimensionsFields.slideUp();
			}
		}

		this.onCountryDestinationChange = function() {
			myInstance.fillUpSelectOfDestinationCities();
		}

		this.fillUpSelectOfDestinationCities = function() {
			var country = $( "#pricing_form__country_destination" ).val();
			var countriesWithCities = $( this.form ).data( "countries_with_cities" );
			var $citySelect = $( "#pricing_form__city_destination" );
			var $citySelectWrap = $( "#js--pricing_form__country_destination__wrap" );
			if( !country || countriesWithCities.indexOf( country ) < 0 ) {
				$citySelect.empty(); // remove old options
				if( $citySelect.is( ":visible" ) ) {
					$citySelectWrap.fadeOut();
				}
			} else {
				var url = "/api/" + $( "html" ).attr( "lang" ) + "/cities/";
				$.ajax( {
					dataType: "json",
					url: url,
					data: {
						country: country,
						format: "json"
					},
					success: function( json ) {
						$citySelectWrap.hide();
						$citySelect.empty(); // remove old options
						console.log( json );
						$.each( json, function( k, item ) {
							$citySelect.append(
								$("<option></option>")
								.attr( "value", item.choice_key )
								.text( item.name )
							);
						} );
						$citySelectWrap.removeClass( "d-none" );
						$citySelectWrap.fadeIn();
					}
				} );
			}
		}

		// Handle data coming
		this.onData = function() {
			myInstance.loaderGraphic.hide();

			// TODO: populate resultContainer with cards
			myInstance.resultContainer.slideDown();
		}

		// Handle Submit Button
		this.onSubmit = function( e ) {
			e.preventDefault();
			var $form = $( this.form );
			if( ! myInstance.checkEmptyFields() ) {
				myInstance.showEmptyFieldsMessage();
				return;
			}
			var url = $form.attr( "action" ) + "?" + $form.serialize();
			var documentNewUrl =
				window.location.toString().
				replace( /#.*/, "" ). // http://dhl-servicepoint2.localhost/bg/#price -> http://dhl-servicepoint2.localhost/bg/
				replace( /\?.*/, "" ) +
				"?" + $form.serialize();
			console.log( documentNewUrl );
			myInstance.submitButton.hide();
			myInstance.checkImportButton.hide();
			myInstance.loaderGraphic.show();

			$.ajax( {
				url: url
			} ).done( function( data ) {
				myInstance.resultContainer.html( data );
				myInstance.onData();
				if ( $( data ).closest( "#js--form_errors" ).length === 0 ) {
					myInstance.dimensionsDisclaimer.show();
				}
				window.history.replaceState( {}, "", documentNewUrl );
			} );
		}

		// Checks if required fields are nonempty and enables/disables submit.
		this.checkEmptyFields = function() {
			var $form = $( this.form );
			if (
				$form.find( "#pricing_form__country_destination" ).val() === "" ||
				$form.find( "#pricing_form__package_hidden" ).val() === "" ||
				( $form.find( "#pricing_form__package_hidden" ).val() === "custom" && $form.find( "#id_size_weight" ).val().trim() === "" ) ||
				(
					$form.find( "#pricing_form__package_hidden" ).val() === "custom" &&
					$form.find( "#id_size_length" ).data( "required" ) === "required" && (
						$form.find( "#id_size_length" ).val().trim() === "" ||
						$form.find( "#id_size_width" ).val().trim() === "" ||
						$form.find( "#id_size_height" ).val().trim() === ""
					)
				)
			) {
				$form.find( "#pricing_form__submit" ).addClass( "disabled" );
				return false;
			} else {
				$form.find( "#pricing_form__submit" ).removeClass( "disabled" );
				$form.find( "#pricing_form__alert" ).hide();
				$form.find( ".js--common-error" ).show();
				$form.find( ".js--weight-required" ).hide();
				$form.find( ".js--dimensions-required" ).hide();
				return true;
			}
		}

		// Show message if required fields are empty
		this.showEmptyFieldsMessage = function() {
			var $form = $( this.form );

			if (
				$form.find( "#pricing_form__country_destination" ).val() !== "" &&
				$form.find( "#pricing_form__package_hidden" ).val() === "custom" &&
				$form.find( "#id_size_length" ).data( "required" ) === "required" &&
				(
					$form.find( "#id_size_length" ).val().trim() === "" ||
					$form.find( "#id_size_width" ).val().trim() === "" ||
					$form.find( "#id_size_height" ).val().trim() === ""
				)
			) {
				$form.find( ".js--common-error" ).hide();
				$form.find( ".js--weight-required" ).hide();
				$form.find( ".js--dmmensions-required" ).show();
			} else if (
				$form.find( "#pricing_form__country_destination" ).val() !== "" &&
				$form.find( "#pricing_form__package_hidden" ).val() === "custom" &&
				$form.find( "#id_size_weight" ).val().trim() === ""
			) {
				$form.find( ".js--common-error" ).hide();
				$form.find( ".js--weight-required" ).show();
				$form.find( ".js--dimensions-required" ).hide();
			} else {
				$form.find( ".js--common-error" ).show();
				$form.find( ".js--weight-required" ).hide();
				$form.find( ".js--dimensions-required" ).hide();
			}

			$form.find( "#pricing_form__alert" ).show();
		}

		// On the initial GET request the pricing cards may be allready rendered in the page
		this.checkInitialDataFullnes = function() {
			if( myInstance.resultContainer.html().trim() === "" ){
				return;
			}

			myInstance.submitButton.hide();
			myInstance.checkImportButton.hide();
			myInstance.resultContainer.show();
			if( myInstance.form.find( "#pricing_form__package" ).val() === "custom" ) {
				myInstance.dimensionsFields.show();
			}
		}

		// Hide results, show submit btn when something in the form changes
		this.reset = function(){
			myInstance.checkEmptyFields();
			myInstance.loaderGraphic.hide();
			myInstance.resultContainer.addClass( "sliding-up" ); // for nicer spacing just during transition
			myInstance.resultContainer.slideUp( { complete: function() { myInstance.resultContainer.removeClass( "sliding-up" ); } } );
			myInstance.submitButton.show();
			myInstance.checkImportButton.show();
			myInstance.dimensionsDisclaimer.slideUp();
		}

		this.init = function() {
			this.checkEmptyFields();
			this.find( "#pricing_form__package" ).on( "change", this.onPackageChange );
			this.submitButton.on( "click", this.onSubmit );
			this.find( ".form-control" ).on( "change", this.reset );
			this.checkInitialDataFullnes();
			this.find( "#pricing_form__country_destination" ).on( "change", this.onCountryDestinationChange );
			this.fillUpSelectOfDestinationCities();
		}

		if ( this.length ) {
			this.init();
		}
	}
} );

	$( "#pricing_form" ).PricingForm( {} );
} )( this )
